import { Resource } from "./dataAccess";
import { DataAccessFactory } from "./DataAccessFactory";

class TrainingFactory extends DataAccessFactory {

    constructor() {
        super();

        this.server = 'training';

        this.initialize()
    }

    initialize(){
        var resources: Resource[] = [
            {
                name: 'TrainingStatus',
                url: 'training/:applicationId/status',
                actions: {
                    get: {
                        method: 'GET',
                        params: { applicationId: '@applicationId' }
                    }
                }
            },
            {
                name: 'TrainingAccountDetails',
                url: 'training/:applicationId/account',
                actions: {
                    get: {
                        method: 'GET',
                        params: { applicationId: '@applicationId' }
                    }
                }
            }
        ]

        this.process(resources);
    }
}

new TrainingFactory();